import React from 'react';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import config from './config';
import Massive from './pages/Massive';
import Images from './pages/Images';
import Layout from '../../components/Layout';

const path = config.PATH;
const name = config.NAME;

const routes = [
  {
    name,
    path,
    component: Layout,
    icon: <CloudUploadIcon />,
    routes: [
      { name: 'Carga Masiva', path: `${path}/masiva`, component: Massive },
      { name: 'Subir Imágenes', path: `${path}/imagenes`, component: Images },
    ],
  },
];

export default routes;
